var enus = {
	"coupon-callout": {
	"coupon-code": "Code",
	"coupon-message-with-price": "Just {{ price }}",
	"coupon-expiry-message": "Expires {{ Date }}.",
	"code-at-checkout": "Enter code at checkout. Cannot be combined with other promo codes, promotions or discounts.",
	"cancel-icon": "Cancel",
	"info-icon": "See details",
	"check-icon": "Applied",
	"promo-code": "Promo Code",
	"coupon-callout-popover": "Coupon Callout Popover"
}
};

export { enus as default };
//# sourceMappingURL=src-localization-texts-en-us.json.js.map
